import { useState, useEffect } from 'react';
import axios from 'axios';

function useDeviceScanSession(companyKey, sessionId) {
    const [deviceScan, setDeviceScan] = useState(null);
    const [sdkMetadata, setSdkMetadata] = useState(null);

    useEffect(() => {
        axios.get('/dash/device_scan/sdk/metadata').then(response => {
            setSdkMetadata(response.data);
        });
    }, []);

    useEffect(() => {
        if (!companyKey || !sessionId) {
            setDeviceScan(undefined);
            return undefined;
        }
        setDeviceScan(null);
        const timer = setTimeout(() => {
            const requestHeaders = { headers: { company_key: companyKey } };
            axios.get('/dash/device_scan/session/' + sessionId, requestHeaders).then(response => {
                setDeviceScan(response.data);
            }).catch(() => {
                setDeviceScan(undefined);
            });
        }, 500);
        return () => clearTimeout(timer);
    }, [companyKey, sessionId]);

    return { deviceScan, sdkMetadata };
}

export default useDeviceScanSession;
